module.exports = __webpack_public_path__ + "img/ms.a6043f08.gif";